import { useCallback, useState, useEffect } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

interface ReviewResponse {
  id: string
  avatar: string | null
  name: string
  message: string
}

interface Review {
  id: string
  avatar: string | null
  name: string
  review_date: string
  review_rating: number
  message: string
  source: string
  review_type: string
  responses: ReviewResponse[]
}

export const useReviews = ({ id, type }: { id: string; type: string }) => {
  const [reviews, setReviews] = useState<Review[]>()
  const [page, setPage] = useState(1)
  const [isLoadMore, setIsLoadMore] = useState(false)

  const getReviews = useCallback(() => {
    _data.get(`${Project.liveApi}reviews/${type}/${id}/`).then((data) => {
      if (data.next !== null) {
        setPage(page + 1)
        setIsLoadMore(true)
      }
      setReviews(data.results)
    })
  }, [])

  const loadMore = useCallback(() => {
    _data
      .get(`${Project.liveApi}reviews/${type}/${id}/?page=${page}`)
      .then((data) => {
        if (data.next !== null) {
          setPage(page + 1)
          setIsLoadMore(true)
        } else {
          setIsLoadMore(false)
        }
        setReviews([...reviews, ...data.results])
      })
  }, [page, reviews])

  return {
    getReviews,
    reviews,
    loadMore,
    isLoadMore,
  }
}
